var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnjoy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 278,
    height: 160,
    viewBox: "0 0 278 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Union_1",
    x: 0,
    y: 0,
    width: 278,
    height: 160,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 142.71,
    height: 42.894,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_70_2",
    "data-name": "Component 70 \\u2013 2",
    transform: "translate(30 20)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -30, -20)",
    filter: "url(#Union_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1-2",
    "data-name": "Union 1",
    d: "M17,100a3,3,0,0,1-3-3V61L0,50,14,39V3a3,3,0,0,1,3-3H215a3,3,0,0,1,3,3V97a3,3,0,0,1-3,3Z",
    transform: "translate(30 20)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(50.29 28.553)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 0.564,
    height: 41.325,
    transform: "translate(57.953 1.569)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M78.768,40.054a.9.9,0,0,1-.251-.033.56.56,0,0,1-.206-.106.492.492,0,0,1-.142-.173.544.544,0,0,1-.052-.251.5.5,0,0,1,.163-.383.684.684,0,0,1,.488-.152h.489v-.118a.338.338,0,0,0-.094-.26.467.467,0,0,0-.315-.086.574.574,0,0,0-.246.047.627.627,0,0,0-.178.122l-.235-.219a.769.769,0,0,1,.3-.2,1.022,1.022,0,0,1,.37-.061,1.275,1.275,0,0,1,.388.054l.318-.309.254.242-.291.276a.607.607,0,0,1,.1.364v1.226h-.373v-.8h-.44c-.224,0-.336.083-.336.253a.231.231,0,0,0,.085.191.412.412,0,0,0,.259.068v.308Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M82.337,40.033v-.209a.6.6,0,0,1-.487.232.688.688,0,0,1-.263-.049.578.578,0,0,1-.2-.144.718.718,0,0,1-.13-.219.824.824,0,0,1-.044-.274V38.2h.372v1.117a.4.4,0,0,0,.107.313.376.376,0,0,0,.262.1.31.31,0,0,0,.135-.034.385.385,0,0,0,.123-.1.441.441,0,0,0,.084-.142.485.485,0,0,0,.034-.183V38.2H82.7v1.835Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M82.426,40.7c0-.037,0-.059-.013-.069a.049.049,0,0,0-.041-.014h-.136V40.3h.158a.892.892,0,0,1,.177.015.24.24,0,0,1,.118.06.237.237,0,0,1,.065.119.79.79,0,0,1,.02.207v.325h-.348Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M84.567,38.87v1.163H84.2V38.952l-.177-.245a1.144,1.144,0,0,1,.376-.4.965.965,0,0,1,.511-.129.891.891,0,0,1,.618.188.687.687,0,0,1,.205.538v1.126h-.363v-1.1a.413.413,0,0,0-.121-.332.532.532,0,0,0-.344-.1.662.662,0,0,0-.234.046.669.669,0,0,0-.222.143Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M87.44,39.533a.517.517,0,0,0,.175.141.428.428,0,0,0,.193.049.328.328,0,0,0,.282-.122.5.5,0,0,0,.091-.306v-.371a.5.5,0,0,0-.086-.295.33.33,0,0,0-.287-.123.394.394,0,0,0-.218.07.5.5,0,0,0-.168.2l-.317-.159a.809.809,0,0,1,.3-.326.773.773,0,0,1,.406-.115.718.718,0,0,1,.542.2.769.769,0,0,1,.19.541V39.3a.921.921,0,0,1-.043.286.653.653,0,0,1-.132.24.627.627,0,0,1-.227.163.807.807,0,0,1-.33.061.787.787,0,0,1-.334-.079.875.875,0,0,1-.294-.228Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 1.358,
    height: 0.285,
    transform: "translate(87.142 37.572)",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M90.395,38.2v.209a.646.646,0,0,1,.226-.179.665.665,0,0,1,.261-.053.682.682,0,0,1,.264.049.568.568,0,0,1,.206.144.7.7,0,0,1,.13.218.833.833,0,0,1,.045.274v1.173h-.373V38.915a.356.356,0,0,0-.373-.408.278.278,0,0,0-.136.035.371.371,0,0,0-.122.094.45.45,0,0,0-.087.143.482.482,0,0,0-.031.181v1.073h-.373V38.2Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M93.779,39.21a.669.669,0,0,0-.335.08.209.209,0,0,0,.019.369.608.608,0,0,0,.32.075.394.394,0,0,0,.348-.131.578.578,0,0,0,.089-.334V38.2h.373v1.071a1.2,1.2,0,0,1-.043.33.59.59,0,0,1-.389.407,1.192,1.192,0,0,1-.378.053,1.036,1.036,0,0,1-.417-.069.69.69,0,0,1-.246-.17.5.5,0,0,1-.113-.2.657.657,0,0,1-.027-.163.564.564,0,0,1,.044-.214.533.533,0,0,1,.142-.179.385.385,0,0,1-.135-.15.577.577,0,0,1-.051-.2.538.538,0,0,1,.131-.365A.485.485,0,0,1,93.5,38.2h.282v.327h-.246a.191.191,0,0,0-.149.047.231.231,0,0,0-.042.148.15.15,0,0,0,.1.138.875.875,0,0,0,.335.053Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M94.15,37.83a.8.8,0,0,1,.03-.242.4.4,0,0,1,.086-.142.239.239,0,0,1,.113-.068.482.482,0,0,1,.125-.016h.531v.3h-.507c-.044,0-.064.055-.064.164Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M100.546,38.2l.436,1.236.181-1.236h.368l-.312,1.835H100.9l-.482-1.259-.482,1.259h-.323L99.307,38.2h.367l.182,1.236.435-1.236Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M103.166,40.054a.886.886,0,0,1-.249-.033.552.552,0,0,1-.206-.106.481.481,0,0,1-.142-.173.57.57,0,0,1-.053-.251.508.508,0,0,1,.162-.383.691.691,0,0,1,.488-.152h.492v-.118a.332.332,0,0,0-.1-.26.459.459,0,0,0-.313-.086.572.572,0,0,0-.247.047.6.6,0,0,0-.176.122l-.237-.219a.782.782,0,0,1,.3-.2,1.009,1.009,0,0,1,.369-.061c.512,0,.769.21.769.627v1.226h-.372v-.8h-.443c-.223,0-.334.083-.334.253a.233.233,0,0,0,.084.191.412.412,0,0,0,.259.068v.308Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M103.326,37.4c0,.112.022.169.06.169h.87v.285h-.911a.506.506,0,0,1-.127-.015.249.249,0,0,1-.115-.066.4.4,0,0,1-.083-.139.658.658,0,0,1-.034-.234Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M105.415,39.45a.457.457,0,0,0,.123.213.277.277,0,0,0,.191.074.254.254,0,0,0,.214-.082.344.344,0,0,0,.067-.222v-.928h-.254V38.2h.621v1.245a.6.6,0,0,1-.168.453.68.68,0,0,1-.48.16.636.636,0,0,1-.4-.122.758.758,0,0,1-.238-.33Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M108.049,40.033h-.364v-1.15a.762.762,0,0,1,.055-.3.661.661,0,0,1,.158-.226.572.572,0,0,1,.279-.145,1.349,1.349,0,0,1,.307-.036,1.385,1.385,0,0,1,.309.036.574.574,0,0,1,.277.145.657.657,0,0,1,.156.226.744.744,0,0,1,.058.3v1.15h-.363V38.916a.387.387,0,0,0-.116-.316.58.58,0,0,0-.636-.006.391.391,0,0,0-.12.3v.069a.607.607,0,0,1,.148-.015h.305v.3h-.269a.172.172,0,0,0-.145.048.22.22,0,0,0-.039.143Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 1.498,
    height: 0.285,
    transform: "translate(107.734 37.572)",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M110.39,38.883a.723.723,0,0,1,.057-.3.606.606,0,0,1,.157-.224.564.564,0,0,1,.275-.145,1.412,1.412,0,0,1,.31-.037,1.376,1.376,0,0,1,.309.037.555.555,0,0,1,.275.145.635.635,0,0,1,.159.224.815.815,0,0,1,.056.3v1.149h-.363V38.915a.388.388,0,0,0-.117-.315.563.563,0,0,0-.638,0,.385.385,0,0,0-.117.315v.595a.224.224,0,0,0,.04.145.177.177,0,0,0,.146.05h.164v.327h-.2a.507.507,0,0,1-.388-.14.541.541,0,0,1-.128-.376Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M116.874,38.2h.368v1.368a.265.265,0,0,0,.019.1c.012.024.042.037.086.037h.181v.328h-.216a.417.417,0,0,1-.339-.123.536.536,0,0,1-.1-.341Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M119.79,38.2l.437,1.236.182-1.236h.367l-.313,1.835h-.317l-.482-1.259-.482,1.259h-.324L118.55,38.2h.368l.184,1.236.434-1.236Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M120.519,37.276v.277h-.167v-.277h-.313v.277h-1.254v.3h2.048v-.581Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 0.348,
    height: 0.672,
    transform: "translate(120.484 36.389)",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M122.554,39.233h-.361c0,.042,0,.081,0,.116a.325.325,0,0,0,.024.093.438.438,0,0,0,.134.2.4.4,0,0,0,.269.088.441.441,0,0,0,.217-.049.365.365,0,0,0,.136-.134.611.611,0,0,0,.064-.2,1.471,1.471,0,0,0,.019-.235,1.444,1.444,0,0,0-.019-.216.619.619,0,0,0-.076-.2.4.4,0,0,0-.152-.143.478.478,0,0,0-.243-.055.591.591,0,0,0-.245.051.862.862,0,0,0-.243.173l-.266-.2a1.51,1.51,0,0,1,.342-.262.922.922,0,0,1,.422-.088.81.81,0,0,1,.629.237,1.023,1.023,0,0,1,.215.7,1.046,1.046,0,0,1-.211.692.734.734,0,0,1-.589.248.773.773,0,0,1-.468-.141.82.82,0,0,1-.276-.389.649.649,0,0,1-.024-.116c-.006-.047-.011-.1-.013-.153s-.005-.109-.007-.165,0-.108,0-.157h.721Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M125.24,39.233h-.365c0,.042,0,.081,0,.116a.232.232,0,0,0,.024.093.437.437,0,0,0,.137.2.385.385,0,0,0,.267.088.444.444,0,0,0,.217-.049.377.377,0,0,0,.135-.134.566.566,0,0,0,.065-.2,1.6,1.6,0,0,0,.018-.235,1.323,1.323,0,0,0-.019-.216.64.64,0,0,0-.074-.2.444.444,0,0,0-.152-.143.5.5,0,0,0-.244-.055.6.6,0,0,0-.248.051.848.848,0,0,0-.238.173l-.271-.2a1.517,1.517,0,0,1,.344-.262.926.926,0,0,1,.421-.088.812.812,0,0,1,.63.237,1.013,1.013,0,0,1,.215.7,1.051,1.051,0,0,1-.21.692.739.739,0,0,1-.589.248.766.766,0,0,1-.467-.141.8.8,0,0,1-.279-.389,1.129,1.129,0,0,1-.023-.116c-.005-.047-.011-.1-.013-.153s0-.109-.007-.165,0-.108,0-.157h.722Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M128.387,40.033v-.209a.625.625,0,0,1-.225.178.655.655,0,0,1-.26.054.7.7,0,0,1-.265-.049.587.587,0,0,1-.2-.144.673.673,0,0,1-.127-.219.776.776,0,0,1-.048-.274V38.2h.374v1.117a.4.4,0,0,0,.107.313.372.372,0,0,0,.261.1.311.311,0,0,0,.136-.034.381.381,0,0,0,.122-.1.446.446,0,0,0,.086-.142.485.485,0,0,0,.033-.183V38.2h.372v1.835Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M129.775,38.52a.779.779,0,0,1,.263-.252.7.7,0,0,1,.357-.089.632.632,0,0,1,.469.159.621.621,0,0,1,.157.459v1.235h-.364V38.805a.367.367,0,0,0-.059-.221.233.233,0,0,0-.2-.082.384.384,0,0,0-.327.182Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M132.624,40.033h-.363v-1.15a.744.744,0,0,1,.057-.3.609.609,0,0,1,.157-.226.579.579,0,0,1,.277-.145,1.344,1.344,0,0,1,.618,0,.571.571,0,0,1,.276.145.648.648,0,0,1,.158.226.78.78,0,0,1,.056.3v1.15H133.5V38.916a.385.385,0,0,0-.118-.316.475.475,0,0,0-.319-.1.482.482,0,0,0-.316.092.4.4,0,0,0-.121.3v.069a.628.628,0,0,1,.151-.015h.3v.3h-.268a.18.18,0,0,0-.147.048.226.226,0,0,0-.039.143Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M135.6,38.557a.287.287,0,0,0-.1.139.548.548,0,0,0-.034.2v.612a.222.222,0,0,0,.039.145.162.162,0,0,0,.142.05h.165v.328h-.2a.513.513,0,0,1-.39-.141.535.535,0,0,1-.129-.376v-.655a.718.718,0,0,1,.059-.3.671.671,0,0,1,.16-.224.61.61,0,0,1,.154-.1,1.145,1.145,0,0,1,.2-.069l.259.263.254-.263a.854.854,0,0,1,.2.066.584.584,0,0,1,.157.1.661.661,0,0,1,.217.522v1.172H136.4V38.9a.566.566,0,0,0-.035-.2.285.285,0,0,0-.1-.14l-.2.2a.2.2,0,0,1-.262,0Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M97.817,39.117a.549.549,0,1,1-.548-.548.548.548,0,0,1,.548.548",
    fill: "#e50019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M115.22,39.117a.548.548,0,1,1-.547-.548.547.547,0,0,1,.547.548",
    fill: "#e50019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M78.394,33.331a.939.939,0,0,1-.379-.759.925.925,0,0,1,.941-.927.969.969,0,0,1,.576.183,3.857,3.857,0,0,0,2.339.823c.824,0,1.322-.325,1.322-.862v-.027c0-.509-.313-.772-1.845-1.164-1.841-.471-3.033-.98-3.033-2.8v-.028c0-1.661,1.334-2.758,3.2-2.758a5.326,5.326,0,0,1,2.9.81.932.932,0,0,1-.5,1.727.977.977,0,0,1-.51-.144,3.8,3.8,0,0,0-1.921-.615c-.771,0-1.177.354-1.177.8v.024c0,.6.39.8,1.974,1.2,1.858.483,2.9,1.151,2.9,2.748v.025c0,1.819-1.387,2.838-3.362,2.838a5.908,5.908,0,0,1-3.438-1.1",
    fill: "#0091bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M86.54,29.749v-.026a4.652,4.652,0,0,1,4.772-4.734,4.845,4.845,0,0,1,3.061.928,1.008,1.008,0,0,1,.392.8.981.981,0,0,1-1,.981,1.048,1.048,0,0,1-.6-.2,3.01,3.01,0,0,0-1.869-.653,2.711,2.711,0,0,0-2.654,2.85v.027A2.717,2.717,0,0,0,91.3,32.6a2.942,2.942,0,0,0,1.987-.719.932.932,0,1,1,1.2,1.425,4.822,4.822,0,0,1-7.951-3.556",
    fill: "#0091bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M100.988,33.291V26.152A1,1,0,0,1,102,25.145h5.073a.905.905,0,0,1,.9.9.894.894,0,0,1-.9.888H102.99v1.859h3.492a.9.9,0,0,1,.9.9.892.892,0,0,1-.9.889H102.99v1.923h4.144a.905.905,0,0,1,.9.9.9.9,0,0,1-.9.889H102a1,1,0,0,1-1.007-1.008",
    fill: "#0091bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M109.75,26.1a1,1,0,0,1,1-1.006h.211a1.244,1.244,0,0,1,1.045.588l3.885,5.1v-4.72a.993.993,0,0,1,1.987,0v7.283a1,1,0,0,1-1.008,1.007h-.066a1.243,1.243,0,0,1-1.044-.589l-4.029-5.282v4.9a.993.993,0,1,1-1.986,0Z",
    fill: "#0091bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M119.675,29.749v-.026a4.652,4.652,0,0,1,4.772-4.734,4.838,4.838,0,0,1,3.059.928,1,1,0,0,1,.392.8.981.981,0,0,1-.991.981,1.06,1.06,0,0,1-.6-.2,3.006,3.006,0,0,0-1.869-.653,2.711,2.711,0,0,0-2.653,2.85v.027a2.718,2.718,0,0,0,2.653,2.876,2.95,2.95,0,0,0,1.989-.719.933.933,0,1,1,1.2,1.425,4.822,4.822,0,0,1-7.951-3.556",
    fill: "#0091bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M129.73,33.291V26.152a1,1,0,0,1,1.006-1.007h5.075a.9.9,0,0,1,.9.9.892.892,0,0,1-.9.888H131.73v1.859h3.493a.9.9,0,0,1,.9.9.892.892,0,0,1-.9.889H131.73v1.923h4.147a.9.9,0,0,1,.9.9.893.893,0,0,1-.9.889h-5.141a1,1,0,0,1-1.006-1.008",
    fill: "#0091bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M89.6,18.312h-6.32V16.578h5.2a2.313,2.313,0,1,0,0-4.625h-5.2V10.331h6.208a2.312,2.312,0,1,0,0-4.624H80.8a2.474,2.474,0,0,0-2.5,2.5V20.435a2.476,2.476,0,0,0,2.5,2.5h8.8a2.313,2.313,0,1,0,0-4.626",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M80.8,6.018a2.17,2.17,0,0,0-2.193,2.191V20.435a2.168,2.168,0,0,0,2.193,2.19h8.8a2,2,0,1,0,0-4H82.972V16.265h5.512a2,2,0,1,0,0-4H82.972V10.019h6.519a2,2,0,1,0,0-4Zm8.8,17.231H80.8a2.784,2.784,0,0,1-2.814-2.814V8.209A2.783,2.783,0,0,1,80.8,5.4h8.687a2.623,2.623,0,1,1,0,5.246h-5.9v1h4.891a2.624,2.624,0,1,1,0,5.248H83.593V18H89.6a2.624,2.624,0,1,1,0,5.247",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M103.661,5.573a2.482,2.482,0,0,0-2.482,2.479v5.775l-5.256-6.9a2.931,2.931,0,0,0-2.407-1.309H93.16a2.474,2.474,0,0,0-2.5,2.5V20.591a2.48,2.48,0,1,0,4.96,0V14.5l5.5,7.22a2.933,2.933,0,0,0,2.4,1.307h.112a2.476,2.476,0,0,0,2.5-2.5V8.052a2.482,2.482,0,0,0-2.479-2.479",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M93.159,5.929a2.169,2.169,0,0,0-2.192,2.192V20.592a2.169,2.169,0,0,0,4.339,0V13.578l6.062,7.952a2.606,2.606,0,0,0,2.157,1.185h.113a2.168,2.168,0,0,0,2.192-2.191V8.054a2.169,2.169,0,1,0-4.338,0v6.7L95.676,7.115a2.606,2.606,0,0,0-2.159-1.186Zm-.022,17.454a2.794,2.794,0,0,1-2.792-2.791V8.121a2.785,2.785,0,0,1,2.814-2.815h.358a3.256,3.256,0,0,1,2.652,1.428l4.7,6.172V8.054a2.792,2.792,0,1,1,5.584,0v12.47a2.783,2.783,0,0,1-2.814,2.814h-.113a3.258,3.258,0,0,1-2.651-1.429l-4.945-6.488v5.171a2.793,2.793,0,0,1-2.792,2.791",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M112.344,5.573a2.475,2.475,0,0,0-2.5,2.5v8.508c0,1.6-.658,1.819-1.371,1.819a2.528,2.528,0,0,1-1.621-.634,2.337,2.337,0,0,0-1.489-.507,2.4,2.4,0,0,0-2.415,2.435,2.5,2.5,0,0,0,.953,1.937,7.465,7.465,0,0,0,4.617,1.528,6.354,6.354,0,0,0,4.625-1.684,6.426,6.426,0,0,0,1.707-4.737V8.074a2.475,2.475,0,0,0-2.5-2.5",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M105.36,17.572a2.091,2.091,0,0,0-2.1,2.123,2.2,2.2,0,0,0,.828,1.688,7.174,7.174,0,0,0,4.431,1.466,6.062,6.062,0,0,0,4.4-1.591,6.13,6.13,0,0,0,1.616-4.518V8.075a2.192,2.192,0,1,0-4.383,0v8.508c0,1.909-.959,2.129-1.683,2.129a2.847,2.847,0,0,1-1.807-.693,2.017,2.017,0,0,0-1.3-.447m3.155,5.9a7.771,7.771,0,0,1-4.808-1.594,2.805,2.805,0,0,1-1.073-2.183,2.707,2.707,0,0,1,2.726-2.747,2.65,2.65,0,0,1,1.675.569,2.217,2.217,0,0,0,1.435.574c.448,0,1.059,0,1.059-1.508V8.075a2.815,2.815,0,1,1,5.63,0V16.74a6.729,6.729,0,0,1-1.8,4.957,6.665,6.665,0,0,1-4.847,1.775",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M122.193,18.468a3.97,3.97,0,0,1-3.967-4.145v-.046a3.928,3.928,0,0,1,3.922-4.1,3.973,3.973,0,0,1,3.967,4.15v.043a3.927,3.927,0,0,1-3.922,4.1m6.515-10.445a9.166,9.166,0,0,0-6.515-2.585,8.912,8.912,0,0,0-9.13,8.885v.043a8.719,8.719,0,0,0,2.571,6.255,9.155,9.155,0,0,0,6.514,2.583,8.912,8.912,0,0,0,9.129-8.881v-.046a8.729,8.729,0,0,0-2.569-6.254",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M122.148,10.486a3.622,3.622,0,0,0-3.612,3.79v.045a3.667,3.667,0,0,0,3.657,3.836,3.626,3.626,0,0,0,3.614-3.79v-.046a3.669,3.669,0,0,0-3.659-3.835m.045,8.294a4.276,4.276,0,0,1-4.28-4.459v-.045a4.261,4.261,0,1,1,8.515.045v.046a4.232,4.232,0,0,1-4.235,4.413m0-13.031a8.607,8.607,0,0,0-8.818,8.572v.046a8.41,8.41,0,0,0,2.479,6.032,8.851,8.851,0,0,0,6.294,2.495,8.6,8.6,0,0,0,8.818-8.573v-.045a8.409,8.409,0,0,0-2.478-6.032,8.855,8.855,0,0,0-6.3-2.5m-.045,17.768a9.466,9.466,0,0,1-6.733-2.675,9.037,9.037,0,0,1-2.663-6.475v-.046a9.22,9.22,0,0,1,9.441-9.194A9.473,9.473,0,0,1,128.927,7.8a9.034,9.034,0,0,1,2.662,6.474v.045a9.222,9.222,0,0,1-9.441,9.2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M139.941,5.55a2.726,2.726,0,0,0-2.294,1.361l-3.234,4.616-3.162-4.561A2.769,2.769,0,0,0,128.9,5.572a2.474,2.474,0,0,0-2.5,2.436,2.83,2.83,0,0,0,.578,1.693l4.91,6.667v4.2a2.5,2.5,0,0,0,5.005,0V16.3l4.916-6.632a2.877,2.877,0,0,0,.59-1.662,2.377,2.377,0,0,0-2.457-2.458",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M128.9,5.884a2.161,2.161,0,0,0-2.192,2.125,2.527,2.527,0,0,0,.516,1.508l4.97,6.749v4.3a2.191,2.191,0,0,0,4.383,0V16.2l4.975-6.716a2.534,2.534,0,0,0,.532-1.474,2.076,2.076,0,0,0-2.146-2.147A2.428,2.428,0,0,0,137.9,7.088l-3.493,4.985-3.419-4.928A2.443,2.443,0,0,0,128.9,5.884m5.484,17.5a2.785,2.785,0,0,1-2.815-2.814v-4.1l-4.845-6.585a3.108,3.108,0,0,1-.638-1.876A2.785,2.785,0,0,1,128.9,5.261a3.111,3.111,0,0,1,2.6,1.531l2.907,4.191,2.978-4.25a3.013,3.013,0,0,1,2.55-1.494,2.679,2.679,0,0,1,2.769,2.77,3.158,3.158,0,0,1-.65,1.841L137.2,16.4v4.165a2.785,2.785,0,0,1-2.815,2.814",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M99.033,26.41H97.708v.325h1.614a2.461,2.461,0,0,0-.289-.325",
    fill: "#e50019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M97.71,27.363H95.74c0,.04,0,.081,0,.123,0,.069,0,.136.006.2H97.7Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M97.71,28.316H96.132a2.954,2.954,0,0,0,.289.327H97.71Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M99,28.641a2.775,2.775,0,0,0,.289-.325H97.708v.325Z",
    fill: "#e50019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M99.68,27.485c0-.041,0-.083,0-.122H97.707v.325H99.67a1.693,1.693,0,0,0,.01-.2",
    fill: "#e50019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M97.7,26.41H96.378a2.235,2.235,0,0,0-.287.324H97.7Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M96.654,24.346a1.733,1.733,0,0,1-.349-.486,1.377,1.377,0,0,1-.131-.607h-.437a1.716,1.716,0,0,0,.168.761,2.006,2.006,0,0,0,.369.528,4.912,4.912,0,0,0,.915.72c.053.037.107.07.161.105h.724c-.093-.062-.184-.123-.275-.182a7.167,7.167,0,0,1-1.145-.839",
    fill: "#e50019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M97.71,24.368H96.132a2.858,2.858,0,0,0,.29.324H97.71Z",
    fill: "#e50019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M97.706,23.638h-1.9a1.965,1.965,0,0,0,.127.324h1.774Z",
    fill: "#e50019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M99.286,24.368H97.709v.324H99a2.949,2.949,0,0,0,.289-.324",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M97.706,23.963H99.48a1.91,1.91,0,0,0,.128-.325h-1.9Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M99.243,36.116a1.4,1.4,0,0,0-.135-.618,1.686,1.686,0,0,0-.3-.433,4.862,4.862,0,0,0-.841-.659c-.2-.129-.411-.262-.621-.4h.726a6.257,6.257,0,0,1,1.027.773,2.106,2.106,0,0,1,.424.59,1.743,1.743,0,0,1,.16.751Z",
    fill: "#e50019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M97.71,35.515h1.8a1.582,1.582,0,0,1,.115.327H97.71Z",
    fill: "#e50019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M97.71,34.713h1.323a2.447,2.447,0,0,1,.29.325H97.71Z",
    fill: "#e50019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M95.9,35.515H97.71v.327H95.789a1.584,1.584,0,0,1,.116-.327",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M96.386,34.713h1.323v.325H96.1a2.447,2.447,0,0,1,.29-.325",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M96.385,30.726h1.323v.327H96.094a2.494,2.494,0,0,1,.291-.327",
    fill: "#e50019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M97.8,29.866a7.03,7.03,0,0,0-1.146.839,1.7,1.7,0,0,0-.349.485,1.407,1.407,0,0,0-.129.609,1.487,1.487,0,0,0,.135.637,1.753,1.753,0,0,0,.307.455,4.724,4.724,0,0,0,.84.7c.194.136.4.271.6.413h-.708a6.184,6.184,0,0,1-1.033-.825,2.2,2.2,0,0,1-.422-.613,1.821,1.821,0,0,1-.162-.765,1.738,1.738,0,0,1,.169-.762,2.1,2.1,0,0,1,.368-.528,5.129,5.129,0,0,1,.917-.721l.16-.1h.726c-.094.064-.186.124-.276.183",
    fill: "#e50019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M98.8,30.748a4.709,4.709,0,0,0-.84-.658c-.2-.131-.41-.263-.62-.407h.725a6.267,6.267,0,0,1,1.027.775,2.135,2.135,0,0,1,.424.59,1.762,1.762,0,0,1,.162.751,1.87,1.87,0,0,1-.165.776,2.237,2.237,0,0,1-.368.549,5.267,5.267,0,0,1-.915.762L98.061,34h-.7c.085-.06.172-.121.257-.179a6.787,6.787,0,0,0,1.145-.886,1.9,1.9,0,0,0,.353-.51,1.54,1.54,0,0,0,.13-.628,1.434,1.434,0,0,0-.134-.617,1.644,1.644,0,0,0-.305-.434",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M97.706,31.68h1.971c0,.04,0,.08,0,.122,0,.069,0,.138,0,.2H97.712Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M97.706,32.634h1.579a2.875,2.875,0,0,1-.292.326H97.706Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M96.42,32.96a3.427,3.427,0,0,1-.291-.326h1.578v.326Z",
    fill: "#e50019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M95.735,31.8c0-.042,0-.082,0-.122h1.968V32H95.747a1.843,1.843,0,0,1-.012-.2",
    fill: "#e50019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M98.8,30.748a4.709,4.709,0,0,0-.84-.658c-.2-.131-.41-.263-.62-.407h.725a6.267,6.267,0,0,1,1.027.775,2.135,2.135,0,0,1,.424.59,1.762,1.762,0,0,1,.162.751,1.87,1.87,0,0,1-.165.776,2.237,2.237,0,0,1-.368.549,5.267,5.267,0,0,1-.915.762L98.063,34h-.705c.085-.059.17-.12.255-.178a6.787,6.787,0,0,0,1.145-.886,1.9,1.9,0,0,0,.353-.51,1.54,1.54,0,0,0,.13-.628,1.434,1.434,0,0,0-.134-.617,1.644,1.644,0,0,0-.305-.434",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M97.617,25.547a7.048,7.048,0,0,1,1.146.841,1.716,1.716,0,0,1,.349.484,1.418,1.418,0,0,1,.129.609,1.494,1.494,0,0,1-.135.636,1.772,1.772,0,0,1-.305.457,4.75,4.75,0,0,1-.843.7c-.193.134-.4.271-.6.412h.709a6.228,6.228,0,0,0,1.034-.826,2.243,2.243,0,0,0,.423-.611,1.86,1.86,0,0,0,.159-.766,1.744,1.744,0,0,0-.167-.761,1.969,1.969,0,0,0-.37-.529,4.934,4.934,0,0,0-.915-.721l-.161-.1h-.723c.091.063.182.124.273.181",
    fill: "#e50019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M96.612,26.431a4.736,4.736,0,0,1,.84-.658c.2-.13.411-.265.622-.406h-.726a6.119,6.119,0,0,0-1.028.774,2.077,2.077,0,0,0-.423.588,1.791,1.791,0,0,0-.162.752,1.844,1.844,0,0,0,.167.777,2.182,2.182,0,0,0,.367.548,5.151,5.151,0,0,0,.914.762c.058.038.114.077.169.117h.708c-.086-.061-.171-.12-.257-.178a6.813,6.813,0,0,1-1.146-.888,1.881,1.881,0,0,1-.353-.511,1.5,1.5,0,0,1-.13-.627,1.419,1.419,0,0,1,.134-.618,1.739,1.739,0,0,1,.3-.432",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M99.243,23.253a1.384,1.384,0,0,1-.135.616,1.686,1.686,0,0,1-.3.433,4.676,4.676,0,0,1-.841.659c-.2.132-.411.264-.621.406h.726a6.314,6.314,0,0,0,1.027-.773A2.17,2.17,0,0,0,99.52,24a1.772,1.772,0,0,0,.162-.75Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M96.654,35.023a1.706,1.706,0,0,0-.349.483,1.4,1.4,0,0,0-.131.61h-.437a1.724,1.724,0,0,1,.168-.762,2.067,2.067,0,0,1,.369-.53,4.988,4.988,0,0,1,.915-.718c.053-.036.107-.071.161-.1h.724l-.275.181a7.17,7.17,0,0,0-1.145.841",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M97.713,30.726h1.323a2.537,2.537,0,0,1,.291.325H97.713Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M5.51,7.263a4.057,4.057,0,0,1-1.737.317A3.562,3.562,0,0,1,0,3.827,3.65,3.65,0,0,1,3.932,0,3.19,3.19,0,0,1,5.51.314l-.266,1.5A2.775,2.775,0,0,0,4,1.54,2.053,2.053,0,0,0,1.859,3.8,2.026,2.026,0,0,0,4.007,6.046a2.712,2.712,0,0,0,1.237-.277Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M13.666,5.218c.06.688.629,1.051,1.507,1.059a3.242,3.242,0,0,0,1.555-.391l.244,1.265a4.563,4.563,0,0,1-2.039.43,2.711,2.711,0,0,1-2.969-2.945A2.643,2.643,0,0,1,14.748,1.8c1.72,0,2.491,1.267,2.491,2.854a4.8,4.8,0,0,1-.039.562Zm1.952-1.153a.992.992,0,0,0-.947-1.1,1.07,1.07,0,0,0-1.015,1.1Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M19.149,7.355,17.355,2.028h1.791l.976,3.767h.032l.975-3.767h1.792L21.127,7.355Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M23.382,3.779c0-.784-.026-1.294-.058-1.751h1.529l.047.989h.041a1.443,1.443,0,0,1,1.31-1.11,1.894,1.894,0,0,1,.543.032V3.5a2.688,2.688,0,0,0-.652-.045,1.233,1.233,0,0,0-1.109,1.036A1.768,1.768,0,0,0,25,4.858v2.5H23.382Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M32.5,4.691a2.761,2.761,0,1,1-5.515,0,2.761,2.761,0,1,1,5.515,0m-1.684,0c0-.868-.3-1.621-1.074-1.621s-1.072.753-1.072,1.621.3,1.62,1.072,1.62,1.074-.752,1.074-1.62",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M33.224,3.726c0-.664-.025-1.232-.059-1.7h1.53l.034.744h.033a1.973,1.973,0,0,1,1.648-.914c1.071,0,1.771.729,1.771,2.3v3.2H36.558V4.4c0-.684-.236-1.153-.823-1.153a.882.882,0,0,0-.834.62,1.322,1.322,0,0,0-.054.415V7.355H33.224Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M9.491,1.857A1.932,1.932,0,0,0,7.9,2.62H7.883V.027L6.259.589V7.355H7.883V4.192a.889.889,0,0,1,.866-.946c.609,0,.842.479.842,1.175V7.355h1.627V4.2c0-1.61-.692-2.34-1.727-2.34",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M.064,8.773v12.7l19.057-6.353Z",
    fill: "#004392"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M.064,21.477l19.057,6.352,19.057-6.352V8.773L19.121,15.124Z",
    fill: "#0091bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M.064,23.539v12.7L19.121,29.89Z",
    fill: "#790b16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M.064,36.243l19.057,6.352,19.057-6.352v-12.7L19.121,29.89Z",
    fill: "#e50019"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnjoy);
export default __webpack_public_path__ + "static/media/enjoy.6d20532c5c89b00b499e8a99d0046da2.svg";
export { ForwardRef as ReactComponent };